import * as API_ROUTES from '../../routing/api';
import { PROBLEM_TYPES_RECEIVED, PROBLEM_TYPES_REQUEST, PROBLEM_TYPES_UNLOAD } from '../constants';
import { requests } from '../../helper/agent';
import { userLogout } from './user';
import { SubmissionError } from 'redux-form/lib/SubmissionError';
import { parseApiErrors } from '../../helper/apiUtils';

export const problemTypesRequest = () => ({
  type: PROBLEM_TYPES_REQUEST,
});

export const problemTypesReceived = (data) => ({
  type: PROBLEM_TYPES_RECEIVED,
  data,
});

export const problemTypesUnload = () => ({
  type: PROBLEM_TYPES_UNLOAD,
});

export const problemTypesFetch = () => {
  return (dispatch) => {
    dispatch(problemTypesRequest());
    return requests
      .get(`${API_ROUTES.PROBLEM_TYPES}`)
      .then((response) => dispatch(problemTypesReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        throw new SubmissionError(parseApiErrors(error));
      });
  };
};
